"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkspacesMap = getWorkspacesMap;
exports.packageJsonBelongsToWorkspace = packageJsonBelongsToWorkspace;
exports.processYarnWorkspaces = processYarnWorkspaces;
const baseDebug = require("debug");
const pathUtil = require("path");
const lodash_1 = require("lodash");
const micromatch = require("micromatch");
const debug = baseDebug('snyk-yarn-workspaces');
const lockFileParser = require("snyk-nodejs-lockfile-parser");
const utils_1 = require("../utils");
const errors_1 = require("../errors");
function getWorkspacesMap(file) {
    const yarnWorkspacesMap = {};
    if (!file) {
        return yarnWorkspacesMap;
    }
    try {
        const rootFileWorkspacesDefinitions = lockFileParser.getYarnWorkspaces(file.content);
        if (rootFileWorkspacesDefinitions && rootFileWorkspacesDefinitions.length) {
            yarnWorkspacesMap[file.fileName] = {
                workspaces: rootFileWorkspacesDefinitions,
            };
        }
    }
    catch (e) {
        debug('Failed to process a workspace', e.message);
    }
    return yarnWorkspacesMap;
}
function packageJsonBelongsToWorkspace(packageJsonFileName, yarnWorkspacesMap, workspaceRoot) {
    const workspaceRootFolder = pathUtil.dirname(workspaceRoot.replace(/\\/g, '/'));
    const workspacesGlobs = (yarnWorkspacesMap[workspaceRoot].workspaces || []).map((workspace) => pathUtil.join(workspaceRootFolder, workspace));
    const match = micromatch.isMatch(packageJsonFileName.replace(/\\/g, '/'), workspacesGlobs.map((p) => pathUtil.normalize(pathUtil.join(p, '**')).replace(/\\/g, '/')));
    return match;
}
async function processYarnWorkspaces(root, settings, targetFiles) {
    // the order of yarnTargetFiles folders is important
    // must have the root level most folders at the top
    const mappedAndFiltered = targetFiles
        .map((p) => ({ path: p, ...pathUtil.parse(p) }))
        .filter((res) => ['package.json', 'yarn.lock'].includes(res.base));
    const sorted = (0, lodash_1.sortBy)(mappedAndFiltered, 'dir');
    const yarnTargetFiles = (0, lodash_1.groupBy)(sorted, 'dir');
    debug(`Processing potential Yarn workspaces (${targetFiles.length})`);
    if (settings.yarnWorkspaces && Object.keys(yarnTargetFiles).length === 0) {
        throw (0, errors_1.NoSupportedManifestsFoundError)([root]);
    }
    let yarnWorkspacesMap = {};
    const yarnWorkspacesFilesMap = {};
    const result = {
        plugin: {
            name: 'snyk-nodejs-yarn-workspaces',
            runtime: process.version,
        },
        scannedProjects: [],
    };
    let rootWorkspaceManifestContent = {};
    // the folders must be ordered highest first
    for (const directory of Object.keys(yarnTargetFiles)) {
        debug(`Processing ${directory} as a potential Yarn workspace`);
        let isYarnWorkspacePackage = false;
        let isRootPackageJson = false;
        const packageJsonFileName = pathUtil.join(directory, 'package.json');
        const packageJson = (0, utils_1.getFileContents)(root, packageJsonFileName);
        yarnWorkspacesMap = {
            ...yarnWorkspacesMap,
            ...getWorkspacesMap(packageJson),
        };
        for (const workspaceRoot of Object.keys(yarnWorkspacesMap)) {
            const match = packageJsonBelongsToWorkspace(packageJsonFileName, yarnWorkspacesMap, workspaceRoot);
            if (match) {
                debug(`${packageJsonFileName} matches an existing workspace pattern`);
                yarnWorkspacesFilesMap[packageJsonFileName] = {
                    root: workspaceRoot,
                };
                isYarnWorkspacePackage = true;
            }
            if (packageJsonFileName === workspaceRoot) {
                isRootPackageJson = true;
                rootWorkspaceManifestContent = JSON.parse(packageJson.content);
            }
        }
        if (!(isYarnWorkspacePackage || isRootPackageJson)) {
            debug(`${packageJsonFileName} is not part of any detected workspace, skipping`);
            continue;
        }
        try {
            const rootDir = isYarnWorkspacePackage
                ? pathUtil.dirname(yarnWorkspacesFilesMap[packageJsonFileName].root)
                : pathUtil.dirname(packageJsonFileName);
            const rootYarnLockfileName = pathUtil.join(rootDir, 'yarn.lock');
            const yarnLock = (0, utils_1.getFileContents)(root, rootYarnLockfileName);
            const lockfileVersion = lockFileParser.getYarnLockfileVersion(yarnLock.content);
            let res;
            switch (lockfileVersion) {
                case lockFileParser.NodeLockfileVersion.YarnLockV1:
                    res = await lockFileParser.parseYarnLockV1Project(packageJson.content, yarnLock.content, {
                        includeDevDeps: settings.dev || false,
                        includeOptionalDeps: false,
                        includePeerDeps: false,
                        pruneLevel: 'withinTopLevelDeps',
                        strictOutOfSync: settings.strictOutOfSync === undefined
                            ? true
                            : settings.strictOutOfSync,
                    });
                    break;
                case lockFileParser.NodeLockfileVersion.YarnLockV2:
                    res = await lockFileParser.parseYarnLockV2Project(packageJson.content, yarnLock.content, {
                        includeDevDeps: settings.dev || false,
                        includeOptionalDeps: false,
                        pruneWithinTopLevelDeps: true,
                        strictOutOfSync: settings.strictOutOfSync === undefined
                            ? true
                            : settings.strictOutOfSync,
                    }, {
                        isWorkspacePkg: true,
                        isRoot: isRootPackageJson,
                        rootResolutions: (rootWorkspaceManifestContent === null || rootWorkspaceManifestContent === void 0 ? void 0 : rootWorkspaceManifestContent['resolutions']) || {},
                    });
                    break;
                default:
                    throw new Error('Failed to build dep graph from current project');
            }
            const project = {
                packageManager: 'yarn',
                targetFile: pathUtil.relative(root, packageJson.fileName),
                depGraph: res,
                plugin: {
                    name: 'snyk-nodejs-lockfile-parser',
                    runtime: process.version,
                },
            };
            result.scannedProjects.push(project);
        }
        catch (e) {
            if (settings.yarnWorkspaces) {
                throw e;
            }
            debug(`Error process workspace: ${packageJsonFileName}. ERROR: ${e}`);
        }
    }
    if (!result.scannedProjects.length) {
        debug(`No yarn workspaces detected in any of the ${targetFiles.length} target files.`);
    }
    return result;
}
//# sourceMappingURL=yarn-workspaces-parser.js.map